module.exports = "<div ng-if=\"ifLoading === undefined || (ifLoading !== undefined &amp;&amp; ifLoading)\" layout=row layout-align=\"center center\"><md-progress-circular md-mode=indeterminate md-diameter={{::diameter}}></md-progress-circular></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/spinner/spinner.jade
// module id = 245
// module chunks = 0